import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const WalletWrapper = () => {

    return (
        <Fragment>
            <Outlet/>
        </Fragment>
    )
}

export default WalletWrapper